<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    userComponentProps,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'UcDueDateRuleDisplay',
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    ...userComponentProps,
    value: {
      type: Object,
      required: false,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const dueDateRuleAnchorOptions = ref(null);
  const ux = ref([]);

  const $data = computed(() => ({
    dueDateRuleAnchorOptions: dueDateRuleAnchorOptions.value,
    ux: ux.value,
  }));

  const $$load_dueDateRuleAnchorOptions = () => {
    return $app.value.repo.get('ui_metadata', {
      path: 'due_date_rule_anchor_options',
      map: true,
      key: 'value',
    });
  };

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [{ name: 'dueDateRuleAnchorOptions' }, { name: 'ux' }],
    loaders: { dueDateRuleAnchorOptions: $$load_dueDateRuleAnchorOptions },
    ux: {},
    dataRefs: { dueDateRuleAnchorOptions, ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.value,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('value');
    }
  );

  const actions = {};

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <div class="badge border" v-if="loaded">
    <ItpIcon icon="mdi:payment-clock"> </ItpIcon>
    <span v-if="value.description">
      {{ value.description }}
    </span>
    <span v-if="!value.description">
      <span>
        {{ dueDateRuleAnchorOptions[value.anchor].name }}
      </span>
      <span v-if="value.offset_days">
        <span>
          {{ value.offset_days > 0 ? '+' : '-' }}
        </span>
        <span>
          {{ value.offset_days }}
        </span>
      </span>
    </span>
  </div>
</template>
